<div *ngIf="environment && environment['PianificazioneAddOn']">

  <!-- FILTRI -->
  <div>
    <app-field-viewer
      [(Campi)]="environment['PianificazioneAddOn']['Filters']"
      [(Oggetto)]="filtro"
      (OnChange)="refresh()">
    </app-field-viewer>
  </div>

  <!-- LISTA + MAPPA -->
  <div class="table-responsive d-flex"
       *ngIf="interventiList && interventiList.length > 0">



    <!-- TABELLA -->
    <table class="table bg-white table-hover align-middle mb-0 no-wrap">

      <!-- HEADER -->
      <thead>
        <tr *ngIf="environment['PianificazioneAddOn'] 
                   && environment['PianificazioneAddOn']['CampiLista'] 
                   && environment['PianificazioneAddOn']['CampiLista']['header']">

          <ng-container *ngFor="let campo of environment['PianificazioneAddOn']['CampiLista']['header']; trackBy: trackByField">
            <th scope="col"
                [ngStyle]="campo['titleStyle']"
                [ngClass]="campo['titleClass']">
              {{ campo['nome'] }}
            </th>
          </ng-container>
          <th>Seleziona</th>

        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let item of interventiList | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize; trackBy: trackByItem">

          <ng-container *ngFor="let campo of environment['PianificazioneAddOn']['CampiLista']['header']; trackBy: trackByField">

            <td (click)="select(item)">

              <span class="font-14"
                    [ngClass]="{ 'badge badge-pill px-3': campoUtility.Colore(campo, item) }"
                    [ngStyle]="{
                      'color': campoUtility.Colore(campo, item) ? LightenColor(campoUtility.Colore(campo, item)) : '',
                      'background-color': campoUtility.Colore(campo, item)
                    }">

                    <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
                      <app-field-viewer *ngIf="!CampoIs(campo, ['objArray', 'replace'])" [Campi]="[campo]"  [hideLabel]="true" [Oggetto]="item"></app-field-viewer>
                      <ng-template [ngIf]="campo.type == 'replace' ">
                        {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
                      </ng-template>
                      <ng-template [ngIf]="campo.type == 'objArray' ">
                        <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                          {{obg[campo.field[i]]}}&nbsp;
                        </ng-container>
                      </ng-template>
                   
                   </ng-container>

              </span>

            </td>
          </ng-container>
          <td>
            <input type="checkbox" [(ngModel)]="item.selected" (click)="select(item)">
          </td>
        </tr>

      </tbody>
    </table>

    <!-- MAPPA -->
    <div class="col-8">
      <div class="card" style="height: 600px;">
        <div class="card-body" style="height: 100%;">
          <app-mappa
            [centerMaplat]="centerMaplat"
            [centerMaplon]="centerMaplon"
            [markers]="Markers"
            [circle]="circleMarker"
            (onCircleMarkerChange)="refresh()"
            (onMarkerClick)="onMarkerClick($event)">
          </app-mappa>
        </div>
      </div>
    </div>

  </div>
</div>
